module.exports = __webpack_public_path__ + "static/media/rental-flow-mobile-jp.a3997ed2.png";